import {
    GiftIcon,
    LandmarkIcon,
    SparklesIcon,
    WalletIcon,
} from 'lucide-react-native';
import { View, YStack } from 'tamagui';

import { Icon } from '../../components/icons/Icon';
import { H6Regular } from '../../components/text/Typography';
import { NextAction } from '../../components/tiles/NextAction';

export const NextActions = () => {
    return (
        <>
            <YStack gap={16} maxWidth={400}>
                <H6Regular>Default</H6Regular>
                <NextAction
                    title="Fruitful Cash Account Invitation"
                    description="You have been invited to open a Fruitful Cash account."
                    icon={WalletIcon}
                    primaryAction={{
                        text: 'View invitation',
                        onPress: () => {},
                    }}
                />
            </YStack>

            <YStack gap={16} maxWidth={400}>
                <H6Regular>With Secondary Action</H6Regular>
                <NextAction
                    title="Pending Fund"
                    description="You have a pending fund transfer. Would you like to complete or cancel it?"
                    primaryAction={{
                        text: 'Continue',
                        onPress: () => {},
                    }}
                    secondaryAction={{
                        text: 'Cancel',
                        onPress: () => {},
                    }}
                />
            </YStack>

            <YStack gap={16} maxWidth={400}>
                <H6Regular>Without Description</H6Regular>
                <NextAction
                    title="Your Money Map is here!"
                    icon={SparklesIcon}
                    primaryAction={{
                        text: 'Explore your Money Map',
                        onPress: () => {},
                    }}
                />
            </YStack>

            <YStack gap={16} maxWidth={400}>
                <H6Regular>Custom background color</H6Regular>
                <NextAction
                    backgroundColor="$marigold300"
                    title="Get $100 funding bonus when you complete your first direct deposit to Fruitful!"
                    iconOverride={
                        <View
                            backgroundColor="$marigold500"
                            padding={8}
                            borderRadius={12}
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Icon
                                icon={GiftIcon}
                                size={24}
                                color="$marigold1200"
                            />
                        </View>
                    }
                    primaryAction={{
                        text: 'Set up',
                        onPress: () => {},
                    }}
                />
            </YStack>

            <YStack gap={16} maxWidth={400}>
                <H6Regular>White background with shadow</H6Regular>
                <NextAction
                    backgroundColor="$white"
                    shadow={true}
                    title="Connect your Institutions"
                    description="Connect your accounts to get a complete view of your finances."
                    icon={LandmarkIcon}
                    primaryAction={{
                        text: 'Connect accounts',
                        onPress: () => {},
                    }}
                />
            </YStack>
        </>
    );
};
